export default /* glsl */`
uniform vec2 uResolution;
`;
